export const FETCH_INITIAL_ORGANIZATIONS_REQUEST =
  "FETCH_INITIAL_ORGANIZATIONS_REQUEST";
export const FETCH_INITIAL_ORGANIZATIONS_SUCCESS =
  "FETCH_INITIAL_ORGANIZATIONS_SUCCESS";
export const FETCH_INITIAL_ORGANIZATIONS_FAILURE =
  "FETCH_INITIAL_ORGANIZATIONS_FAILURE";

export const FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST =
  "FETCH_AUTOCOMPLETE_ORGANIZATIONS_REQUEST";
export const FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS =
  "FETCH_AUTOCOMPLETE_ORGANIZATIONS_SUCCESS";
export const FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE =
  "FETCH_AUTOCOMPLETE_ORGANIZATIONS_FAILURE";



// WEBPACK FOOTER //
// ./src/actions/organizations/types.js